// extracted by mini-css-extract-plugin
module.exports = {"FeatureCard":"az_HDc","Content":"az_IDc","Title":"az_JDc","Subtitle":"az_KDc","Spacer":"az_LDc","ImageWrapper":"az_MDc","Image":"az_NDc"};